import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../../constants/calendarGrid'
import { getCalendarRequestLabel } from '../../../Calendar.utils'

function getCalendarTaskMoveStepIndexLabel({ item, t }) {
  return item.stepIndex
    ? t('Calendar.MoveTaskStepKey', {
        index: item.stepIndex,
        total: item.stepTotal,
      })
    : null
}

export function getCalendarTaskMoveStepLabel({ item, t }) {
  return [
    getCalendarTaskMoveStepIndexLabel({ item, t }),
    getCalendarRequestLabel(item.request),
    item.request.building?.short_name,
  ]
    .filter(Boolean)
    .join(CALENDAR_GRID_LABEL_SEPARATOR)
}
